import { MESSAGE_TYPE } from '@/constants/message'

const DEFAULT_TYPE = MESSAGE_TYPE.COMMON
const DEFAULT_TITLE = ''
const DEFAULT_TEXT = ''
const DEFAULT_CLOSE_ON_OVERLAY = true

export default {
    namespaced: true,
    state: {
        type: DEFAULT_TYPE,
        title: DEFAULT_TITLE,
        text: DEFAULT_TEXT,
        closeOnOverlayClick: DEFAULT_CLOSE_ON_OVERLAY,
        show: false
    },
    getters: {
        isStatusWaiting(state) {
            return state.show && state.type === MESSAGE_TYPE.WAITING;
        },
    },
    mutations: {
        show(state, { type, title, text, closable }) {
            state.type = type ?? DEFAULT_TYPE
            state.title = title ?? DEFAULT_TITLE
            state.text = text ?? DEFAULT_TEXT
            state.closeOnOverlayClick = type === MESSAGE_TYPE.WAITING
                ? false
                : (closable ?? DEFAULT_CLOSE_ON_OVERLAY)
            state.show = true
        },
        hide(state) {
            state.show = false
        },
    }
};
